/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  GetStatsByDriversOverviewQueryParams,
  GetStatsByDriversOverview200,
  GetStatsByDriversOverview400,
  GetStatsByDriversOverviewQueryResponse,
} from '../entities/GetStatsByDriversOverview'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { errorStructSchema } from './errorStructSchema'
import { v1StatsByDriversOverviewResponseSchema } from './v1/statsByDriversOverviewResponseSchema'
import { z } from 'zod'

export const getStatsByDriversOverviewQueryParamsSchema = z
  .object({
    drivee_city_id: z.number().int().describe('ID города в Drivee').optional(),
    from: z.string().describe('Начальная дата').optional(),
    phone: z.string().describe('Номер водителя').optional(),
    to: z.string().describe('Конечная дата').optional(),
  })
  .optional() as unknown as ToZod<GetStatsByDriversOverviewQueryParams>

/**
 * @description OK
 */
export const getStatsByDriversOverview200Schema = z.lazy(() => v1StatsByDriversOverviewResponseSchema) as unknown as ToZod<GetStatsByDriversOverview200>

/**
 * @description Bad Request
 */
export const getStatsByDriversOverview400Schema = z.lazy(() => errorStructSchema) as unknown as ToZod<GetStatsByDriversOverview400>

export const getStatsByDriversOverviewQueryResponseSchema = z.lazy(
  () => getStatsByDriversOverview200Schema,
) as unknown as ToZod<GetStatsByDriversOverviewQueryResponse>